var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1456",
    "data-name": "Group 1456",
    transform: "translate(-1002 -277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3324",
    "data-name": "Rectangle 3324",
    transform: "translate(1002 277)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 133,
    rx: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 132,
    height: 132,
    rx: 27.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2986",
    "data-name": "Group 2986",
    transform: "translate(1039.749 314.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2987",
    "data-name": "Group 2987",
    transform: "translate(-2 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3321",
    "data-name": "Rectangle 3321",
    width: 18,
    height: 39,
    transform: "translate(0.251 18.051)",
    fill: "#6c75f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3322",
    "data-name": "Rectangle 3322",
    width: 19,
    height: 40,
    transform: "translate(39.251 17.051)",
    fill: "#6c75f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3546",
    "data-name": "Path 3546",
    d: "M-.2.01,40,0V18l-40.2.02Z",
    transform: "translate(18.251 0.051)",
    fill: "#6c75f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3545",
    "data-name": "Path 3545",
    d: "M672,311.138h17.919v-18.17Z",
    transform: "translate(-671.749 -292.917)",
    fill: "#6c75f1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.aaed4947ea8f304961e44140f56a313b.svg";
export { ForwardRef as ReactComponent };